export const MAP_URL = {
  login: "admin/login",
  advice: "admin/advice",
  adminUsers: "admin/adminUsers",
  user: "admin/user",
  blogCategory: "admin/blogCategory",
  blog: "admin/blog",
  config: "admin/config",
  periods: "admin/periods",
  codes: "admin/codes",
  forumCategory: "admin/forumCategory",
  forum: "admin/forum",
  conversationAdminPanel: "https://adminpanel.messaging.karafsapp.com/#/conversation/",
  lunaDeepLink : 'lunahealth://messageNotification/',
  messageAdminPanel: "https://adminpanel.messaging.karafsapp.com/#/message/",
  report: "admin/report",
  specialistCard: "admin/specialistCard",
  specialistComment: "admin/specialistComment",
  invoice: "admin/invoice",
  adminLogHistory: "admin/logHistory",
  specialistSalesReport: "admin/shop/specialist-sales-count",
  conversation: "admin/conversation",
  message: "admin/messages",
  attachment: "admin/attachment",
  userConversation: "admin/userConversation",
  specialistTransaction: "admin/specialistTransaction",
  conversationAd: "admin/conversationAd",
  avatar: "admin/avatar",
  experiment:"admin/experiment",
  variant:"admin/variant",
  userVariant: "admin/userVariant",
  childWeek: "admin/childWeek",
  marketLogin: "admin/marketLogin",
  welcomeModal: "admin/welcomeModal",
  termsCondition: "admin/terms",
  plan: "admin/plan",
  planType: "admin/planType",
  promotion: "admin/promotion",
  discount: "admin/discount",
  bulkDiscount: "admin/bulkDiscount",
  planFeatures: "admin/planFeature",
  eventBanner: "admin/eventBanner",
  subscription: "admin/subscription"
};
